import "./i18n";

import axios from "axios";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { RemindersProvider } from "./context/RemindersContext";

const digirise = new URLSearchParams(window.location.search).get("digirise");
if (digirise) {
  sessionStorage.setItem("digirise", digirise);

  // Count the visitor once per browser
  if (!localStorage.getItem("digiriseVisitorTracked")) {
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/digirise-visitors`)
      .then(() => localStorage.setItem("digiriseVisitorTracked", "1"))
      .catch((err) => console.error(err));
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <RemindersProvider>
        <App />
      </RemindersProvider>
    </AuthProvider>
  </BrowserRouter>
);
